<template>
    <div class="privacy-policy">

    </div>
</template>

<script>
export default {
    name: 'privacypolicy',
    // get the policy html from
}
</script>

<style>

</style>